import { Card, CardContent, CardFooter } from '@/components/ui/card';

const CardForm = ({ title, subtitle, children, className, footer, endComponent = null }) => {
  return (
    <Card className={className}>
      <CardContent className='tw-p-6 tw-pt-6'>
        <div className='d-flex tw-justify-between align-items-start'>
          <div>
            <h2 className='tw-text-2xl tw-font-semibold tw-mb-1'>{title}</h2>
            <p className='tw/text-sm tw-font-normal tw-text-muted-foreground tw-pb-6'>{subtitle}</p>
          </div>
          {endComponent}
        </div>
        {children}
      </CardContent>
      {footer ? (
        <CardFooter className='tw-border-t tw-justify-center tw-items-center !tw-p-0'>
          {footer}
        </CardFooter>
      ) : null}
    </Card>
  );
};

export default CardForm;
